<template>
    <canvas ref="canvas" class="canvas" width="880" height="400"></canvas>
</template>

<script>
    // var data = [
    //     { label: 'Food', value: 90 },
    //     { label: 'Party', value: 150 },
    //     { label: 'Rent', value: 80 },
    //     { label: 'Chocolates', value: 120 }
    // ];
    export default {
        name: 'PieChart',

        props: {
            myData: {
                type: Array,
                default: []
            }
        },

        methods: {


            drawPieChart () {
                var canvas = this.$refs.canvas;
                var ctx = canvas.getContext('2d');
                var x = canvas.width / 2;
                var y = canvas.height / 2;
                var color,
                    startAngle,
                    endAngle,
                    total = this.getTotal(this.myData);

                const colors = [
                    "#ffc059",
                    "#ff6565",
                    "#708bcc",
                    "#4ad991",
                    "#52dfec",
                    "#a3a0fb",
                    '#095db0'
                ];

                const data = [...this.myData];

                data.sort((a, b) => b.value - a.value)

                const percents = data.slice(0, -1).map(item => {
                    return Math.max(1, Math.floor((item.value / total) * 100));
                })

                percents.push(100 - percents.reduce((x, y) => x + y, 0))


                for(var i=0; i < data.length; i++) {
                    color = colors[i];
                    startAngle = this.calculateStart(data, i, total);
                    endAngle = this.calculateEnd(data, i, total);

                    ctx.beginPath();
                    ctx.fillStyle = color;
                    ctx.moveTo(x, y);
                    ctx.arc(x, y, y-50, startAngle, endAngle);
                    ctx.fill();
                    ctx.rect(canvas.width - 275, y - i * 30, 12, 12);
                    ctx.fill();
                    ctx.font = "20px sans-serif";
                    ctx.fillStyle = '#000';
                    // ctx.fillText(data[i].label + " - " + data[i].value + " (" + this.calculatePercent(data[i].value, total) + "%)", canvas.width - 250 + 20, y - i * 30 + 10);
                    ctx.fillText(data[i].label + " - " + "(" + percents[i] + "%)", canvas.width - 275 + 20, y - i * 30 + 10);
                }
            },

            calculatePercent (value, total) {

                const numero = (value / total * 100).toFixed(2)

                const div = numero.split('.')

                if (div[1] === '00')
                {
                    return div[0]
                } else {
                    return div[0] + '.' + div[1]
                }

                // return numero

            },

            getTotal (data) {
                var sum = 0;
                for(var i=0; i<data.length; i++) {
                    sum += data[i].value;
                }

                return sum;
            },

            calculateStart (data, index, total) {
                if(index === 0) {
                    return 0;
                }

                return this.calculateEnd(data, index-1, total);
            },

            calculateEndAngle (data, index, total) {
                var angle = data[index].value / total * 360;
                var inc = ( index === 0 ) ? 0 : this.calculateEndAngle(data, index-1, total);

                return ( angle + inc );
            },

            calculateEnd (data, index, total) {
                return this.degreeToRadians(this.calculateEndAngle(data, index, total));
            },

            degreeToRadians (angle) {
                return angle * Math.PI / 180
            },

        },

        mounted () {
            this.drawPieChart();
        },

        computed: {
            chart(){
                return this.$refs.canvas;
            }
        },

        watch: {
            myData() {
                this.drawPieChart();
            },
            myLabel() {
                this.drawPieChart();
            }
        }
    }
</script>

<style lang="scss" scoped>
.canvas{
    max-width: 100%;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/canvas-chart/PieChart2.vue